// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"3152":"7c8a9136","6057":"b58a4dff","6603":"1f4baac4"}[chunkId] + ".css";
};